import styled from 'styled-components';

export const TopContainer = styled.div`
  display: flex;
  width: 100%;
`;
